import { createAction, makeActionTrackable } from '@lingoda/core';
import type { StudentId } from '@lingoda/students';
import type { Agreement } from '@lingoda/monolith-graphql';
import type { Subscription } from './models';
import type { ChangeSubscriptionPurchase } from './types';

export const addSubscriptions = createAction<Subscription[]>('subscription/ADD_SUBSCRIPTIONS');

export const setSubscriptions = createAction<Subscription[]>('subscription/SET_SUBSCRIPTIONS');

/** @deprecated Use ChangeSubscriptionPurchase from types.ts instead */
export type ChangeSubscriptionPurchaseLegacy = ChangeSubscriptionPurchase & {
    agreements: ReadonlyArray<Pick<Agreement, 'id'>>;
};

interface ChangeSubscriptionPayload {
    purchase: ChangeSubscriptionPurchaseLegacy;
    agreements?: string[];
}

export const changeSubscription = makeActionTrackable(
    createAction('subscription/CHANGE_SUBSCRIPTION', (payload: ChangeSubscriptionPayload) => ({
        payload,
    })),
);

export const confirmCancelSubscription = makeActionTrackable(
    createAction(
        'subscription/CONFIRM_CANCEL_SUBSCRIPTION',
        (subscriptionId: number, reason: string) => ({
            subscriptionId,
            reason,
        }),
    ),
);

export const uncancelSubscription = makeActionTrackable(
    createAction<number>('subscription/UNCANCEL_SUBSCRIPTION'),
);

const type = 'subscription/FETCH_SUBSCRIPTIONS';
const actionCreator = (payload?: StudentId) => ({
    type,
    payload,
});

actionCreator.toString = () => type;

export const fetchSubscriptions = makeActionTrackable(actionCreator);
